import PrivateRoutes from './container'

export default PrivateRoutes
